/**
 * A compoent with an array of social sharing buttons
 */
import './App.css';

import React, { Component } from 'react';
import app_meta from './meta_data'

let wechatIcon = require('./images/share_wechat.svg')
let weiboIcon = require('./images/share_weibo.svg')
let facebookIcon = require('./images/share_facebook.svg')
let twitterIcon = require('./images/share_twitter.svg')
let wechatQrImage = require('./images/qrCode.png')

// let wechatQrImage = require('./images/qrCode.png')
// let wechatIcon = require('./images/wechat.png')
// let weiboIcon = require('./images/weibo.png')
// let facebookIcon = require('./images/FB.png')
// let twitterIcon = require('./images/twitter.png')

/**
 * Return the link to share a URL in a mansion specified by config
 * @param {object} config - an object containing the configurations of the sharing
 * @returns {string}
 */

function getShareUrl (config) {
  var platform = config.platform
  var facebookAppId = config.facebookAppId
  var targetUrl = config.targetUrl
  var title = config.title
  var description = config.description
  var imageUrl = config.imageUrl

  targetUrl = targetUrl ? encodeURIComponent(targetUrl) : ''
  imageUrl = imageUrl ? encodeURIComponent(imageUrl) : ''

  var shareUrl

  if (platform === 'facebook') {
    shareUrl = 'https://www.facebook.com/dialog/feed?' +
      'app_id=' + facebookAppId +
      '&link=' + targetUrl +
      '&redirect_uri=' + targetUrl

    if (imageUrl) {
      shareUrl += '&picture=' + imageUrl
    }

    if (title) {
      shareUrl += '&name=' + title
    }

    if (description) {
      shareUrl += '&description=' + description
    }

    return shareUrl
  } else if (platform === 'sinaweibo') {
    return 'http://v.t.sina.com.cn/share/share.php?title=' + title + '&url=' + targetUrl
  } else if (platform === 'twitter') {
    return 'https://twitter.com/share?url=' + targetUrl + '&text=' + title
  }
}

let SocialBar = React.createClass({

  propTypes: {
    resetHandler: React.PropTypes.func
  },

  getInitialState: function () {
    return {
      displayWechatQrImage: 'none'
    }
  },

  handleShareButtonClick: function (event) {
    var chosenPlatform = event.target.dataset.platform
    var shareTitle, shareDescription

    if (chosenPlatform === 'facebook') {
      shareTitle = app_meta.appTitle
      shareDescription = app_meta.facebookShareDescription
    } else if (chosenPlatform === 'sinaweibo') {
      shareTitle = app_meta.sinaweiboShareTitle
    } else if (chosenPlatform === 'twitter') {
      shareTitle = app_meta.twitterShareTitle
    }

    var shareUrl = getShareUrl({
      facebookAppId: app_meta.facebookAppId,
      title: shareTitle,
      description: shareDescription,
      platform: chosenPlatform,
      targetUrl: window.location.href
    })
    window.open(shareUrl)
  },

  handleWechatShareButtonClick: function () {
    var display
    if (this.state.displayWechatQrImage === 'none') {
      display = 'block'
    } else {
      display = 'none'
    }

    this.setState({
      displayWechatQrImage: display
    })
  },

  handleWechatCloseClick: function () {
    this.setState({
      displayWechatQrImage: 'none'
    })
  },

  render: function () {
    return (
      <div id='socialBar'>
        <button data-platform='facebook'
                onClick={this.handleShareButtonClick}>
          <img src={facebookIcon}
                 data-platform='facebook' />
        </button>
        <button data-platform='twitter'
                onClick={this.handleShareButtonClick}>
          <img src={twitterIcon}
                 data-platform='twitter' />
        </button>
        <button data-platform='sinaweibo'
                onClick={this.handleShareButtonClick}>
          <img src={weiboIcon}
                 data-platform='sinaweibo' />
        </button>
        <button onClick={this.handleWechatShareButtonClick}>
          <img src={wechatIcon}/>
        </button>
        <div id='qrcode' style={{display: this.state.displayWechatQrImage}}>
          <div>
            <button className="wechatCloseButton" onClick={this.handleWechatCloseClick}>[關閉]</button>
            <div>請用微信掃碼分享</div>
            <img src={wechatQrImage}/>
          </div>
        </div>
      </div>
    )
  }

})

export default SocialBar



/** WEBPACK FOOTER **
 ** ./src/SocialBar.js
 **/